import { useSelector } from "react-redux";
import Loader from "./Loader";
import Home from "./Home/Home";
import SearchPanel from "./SearchPanel/SearchPanel";
import SignInModal from "./SignInModal";
import Notification from "./Notification/Notification";

const Homepage = () => {
  const celebData = useSelector((state) => state.celebData);
  const activeCelebData = useSelector((state) => state.activeCelebData);
  const searchWindow = useSelector((state) => state.searchWindow);

  return celebData.length > 0 && activeCelebData.length > 0 ? (
    <>
      <Home />
      {searchWindow && <SearchPanel />}
      <SignInModal />
      <Notification />
    </>
  ) : (
    <Loader />
  );
};

export default Homepage;
